export default __webpack_public_path__ + "static/m-feature-2-327287142de625105b8ad08a9f5a267f.png";